import { isString } from "../../validate"
import { isInputText } from "./specialChecking"

export default ({ value: str }) => {
  if (!isString(str)) return false

  const hasChineseChars = /[\u4E00-\u9FFF]/.test(str)
  if (hasChineseChars) return false

  const maxCompanyNameLength = 100
  if (str.length <= 0 || str.length > maxCompanyNameLength) return false

  return isInputText(str)
}
